import React, { useState, useEffect } from "react";
import AdminDashboard from "../../AdminDashboard"
import { isAuthenticated } from "../../../../auth"
import { Redirect } from "react-router-dom";
import { updateCategory } from "../../apiAdmin"
import {getCategory} from "../../../apiCore"
import * as qs from 'query-string';
import { from } from "form-data";
import { default_url } from "../../../..";
import { dict } from "../../../../dictionary";

function UpdateCategory() {
    const [values, setValues] = useState({
        _id: "",
        name: "",
        hasSubcategory: "",
        hidden: "",
        image: "",
        error: "",
        redirectToReferrer: false
    });

    const parsed = qs.parse(window.location.search);

    useEffect(() => {
        async function fetchData() {
            const category = await getCategory(parsed.category_id)
                .then(res => {
                    if (res.error) {
                        setValues({ ...values, error: res.error, redirectToReferrer: true });
                    } else {
                        setValues({ _id: res._id, enName: res.enName, arName: res.arName, hasSubcategory: res.hasSubcategory ? "yes" : "no", hidden: res.hidden ? "yes" : "no", image: res.image });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
        fetchData();
    }, []);

    const { user, token } = isAuthenticated();
    const { _id, enName, arName, hasSubcategory, hidden, image, error, redirectToReferrer } = values;

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const clickSubmit = (event) => {
        event.preventDefault();
        updateCategory({ _id, enName, arName, hasSubcategory, hidden, image }, user._id, token)
            .then(data => {
                console.log(data)
                if (data.error) {
                    setValues({ ...values, error: dict[data.error], redirectToReferrer: false });
                } else {
                    setValues({
                        enName: "",
                        arName: "",
                        hasSubcategory: "",
                        hidden: "",
                        image: "",
                        error: undefined,
                        redirectToReferrer: true
                    });
                }
            })
    }

    const hasSubcategorySelector = () => {
        return (
            <select onChange={handleChange("hasSubcategory")} name="hasSubcategory" className="inputField form-control" value={hasSubcategory || ""}>
                <option value=""></option>
                <option value="yes">{dict["yes_._it_has_subcategory"]}</option>
                <option value="no">{dict["no_._it_hasn't_subcategory"]}</option>
            </select>
        )
    }

    const hiddenSelector = () => {
        return (
            <select onChange={handleChange("hidden")} name="hidden" className="inputField form-control" value={hidden || ""}>
                <option value=""></option>
                <option value="yes">{dict["yes_._it_is_hidden"]}</option>
                <option value="no">{dict["no_._it_isn't_hidden"]}</option>
            </select>
        )
    }

    const showError = () => {
        return (
            <div className="alert alert-danger" style={{ display: error ? "" : "none" , textAlign: 'start'}}>
                {error}
            </div>
        )
    }

    const redirectUser = () => {
        if (redirectToReferrer) {
            return (
                <Redirect to={{ pathname: default_url + 'admin/categories', state: { prevPath: "edit", error } }} />
            )
        }
    }

    const arStyleRequiredStart = {
        left: "30px"
    }
    const enStyleRequiredStart = {
        right: "30px"
    }
    const arStylelabel = {
        float: "right"
    }
    const enStylelabel = {
        float: "left"
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showError()}
                {redirectUser()}
                <h3 className="formContainerTitle">{dict["edit_category"]}</h3>
                <h6 className="requiredStar requiredStarUserDashbord" style={default_url == "/en/" ? enStyleRequiredStart : arStyleRequiredStart}>{dict["required"]}</h6>
                <form >
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{"ID"}</label>
                <input type="text" value={_id || ""} className="inputField form-control" disabled ></input>
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["category_english_name"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("enName")} type="text" value={enName || ""} className="inputField form-control" id="name" placeholder={dict["category_english_name"]}></input>
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["category_arabic_name"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("arName")} type="text" value={arName || ""} className="inputField form-control" id="name" placeholder={dict["category_arabic_name"]}></input>
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["has_subcategory"]} <span className="redStar">*</span></label><br />
                {hasSubcategorySelector()}
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["hidden"]} <span className="redStar">*</span></label><br />
                {hiddenSelector()}
                <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["category_image"]} <span className="redStar">*</span></label>
                <input onChange={handleChange("image")} type="text" value={image || ""} className="inputField form-control" id="image" placeholder={dict["category_image"]}></input>
                <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["save"]}</button>
                </form>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="2"
            data={form}
        />
    )
}

export default UpdateCategory;